var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vc-back-btn",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"_icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }